const { stringUtils } = require('../../../utils');

const avoidHeaderEndpointsList = ['/oauth/token'];

const getNested = (item, key) => key.split('.').reduce((o, x) => ((typeof o === 'undefined' || o === null) ? o : o[x]), item);

const getRequestContent = (requestBodyOriginal) => {
  if (!requestBodyOriginal) {
    return {};
  }

  const itemPath = `${requestBodyOriginal.type === 'array' ? 'items.' : ''}properties`;
  let requestBody = getNested(requestBodyOriginal, itemPath);
  requestBody = requestBody || {};
  const variablesNames = Object.keys(requestBody);
  const content = {};

  variablesNames.forEach((variableName) => {
    const variable = requestBody[variableName];
    if (!variable.type) {
      content[variableName] = variable.example;
      return;
    }
    if (variable.type.toLowerCase() === 'object') {
      content[variableName] = getRequestContent(variable);
      return;
    }
    if (variable.type.toLowerCase().indexOf('array') >= 0) {
      content[variableName] = [];
      content[variableName].push(getRequestContent(variable));
      return;
    }
    content[variableName] = variable.example;
  });
  return content;
};

const getParsedParamValueByType = (value, type = 'string') => {
  switch (type) {
    case 'integer':
      return parseInt(value, 10);
    case 'number':
      return parseFloat(value);
    case 'boolean':
      return value === 'true';
    default:
      return value;
  }
};

const getRequestContentForLiveTest = (requestBodyOriginal, type = 'object') => {
  if (!requestBodyOriginal) {
    return {};
  }
  const content = type === 'object' ? {} : [];
  requestBodyOriginal.forEach((requestItem) => {
    if (requestItem?.in !== 'body') {
      return;
    }

    const { name } = requestItem;
    if (!requestItem?.type) {
      content[name] = getParsedParamValueByType(requestItem?.example);
      return;
    }
    if (requestItem?.type?.toLowerCase() === 'object') {
      content[name] = getRequestContentForLiveTest(requestItem?.properties);
      return;
    }
    if (requestItem.type.toLowerCase().indexOf('array') >= 0) {
      content[name] = [];
      content[name].push(getRequestContentForLiveTest(requestItem?.properties));
      return;
    }
    content[name] = getParsedParamValueByType(requestItem.example, requestItem?.type);
  });
  return content;
};

const getHeaderParamContent = (parametersToParse = [], accessToken, apiEndpoint) => {
  const parameters = parametersToParse?.length <= 0 ? [] : parametersToParse.filter((param) => param.in === 'header');
  const maskedAccessToken = stringUtils.maskData(accessToken, 8);
  if (!avoidHeaderEndpointsList.includes(apiEndpoint)) {
    parameters?.push({
      name: 'Authorization',
      type: 'string',
      example: `Bearer ${maskedAccessToken}`,
    });
  }
  return parameters;
};

const getQueryParamContent = (parametersToParse = []) => {
  const parameters = parametersToParse.length <= 0 ? [] : parametersToParse.filter((param) => param.in === 'query');
  if (!parameters || parameters.length <= 0) {
    return '';
  }
  let queryParam = '?';
  parameters.forEach((param) => {
    if (!param?.example) {
      return;
    }
    queryParam += `${param.name}=${param?.example}&`;
  });
  return queryParam.slice(0, -1);
};

const parseRequestBodyProperties = (bodyProperties) => {
  if (!bodyProperties || bodyProperties.length <= 0) {
    return [];
  }
  const keys = Object.keys(bodyProperties);
  return keys.map((key) => {
    const property = bodyProperties[key];
    const childsProps = property.items ? property.items.properties : property.properties;
    return {
      name: key,
      type: property.type,
      required: property.required,
      description: property.description,
      in: 'body',
      properties: childsProps ? parseRequestBodyProperties(childsProps) : null,
      enum: property.enum,
      example: property.example,
    };
  });
};
const getContentRequest = (
  apiMethod,
  serverEndpoint,
  apiEndpoint,
  codeRequestQueryData,
  codeContentRequestData,
  codeContentHeaderData = [],
  referenceContent,
  codeType,
) => {
  try {
    const languageContent = {
      java: referenceContent.paths[apiEndpoint][apiMethod].java,
      bash: referenceContent.paths[apiEndpoint][apiMethod].bash,
      php: referenceContent.paths[apiEndpoint][apiMethod].php,
      js: referenceContent.paths[apiEndpoint][apiMethod].js,
      ruby: referenceContent.paths[apiEndpoint][apiMethod].ruby,
      csharp: referenceContent.paths[apiEndpoint][apiMethod].csharp,
      python: referenceContent.paths[apiEndpoint][apiMethod].python,
    };

    if (codeType && languageContent[codeType]) {
      return languageContent[codeType];
    }

    const curlCommand = `curl -X ${apiMethod.toUpperCase()} \\
    '${serverEndpoint}${apiEndpoint}${codeRequestQueryData}'\\
    -H 'Content-Type: application/json' \\${codeContentHeaderData?.map((item) => `\n       -H '${item?.name}: ${item?.example}' \\`).join('')}
    ${codeContentRequestData === '{}' ? '' : `-d '${codeContentRequestData}'`}`;

    return curlCommand;
  } catch (error) {
    console.error(error);

    const curlCommand = `curl -X ${apiMethod.toUpperCase()} \\
    '${serverEndpoint}${apiEndpoint}${codeRequestQueryData}'\\
    -H 'Content-Type: application/json' \\${codeContentHeaderData?.map((item) => `\n       -H '${item?.name}: ${item?.example}' \\`).join('')}
    ${codeContentRequestData === '{}' ? '' : `-d '${codeContentRequestData}'`}`;

    return curlCommand;
  }
};

module.exports = {
  getRequestContent,
  getQueryParamContent,
  parseRequestBodyProperties,
  getNested,
  getContentRequest,
  getRequestContentForLiveTest,
  getHeaderParamContent,
  avoidHeaderEndpointsList,
};
